import { z } from 'zod';

import {
  type PerformanceByCompetenceResponse,
  performanceByCompetenceResponseSchema,
} from '@/features/performance-dashboard/schemas/performanceByCompetence';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getBenchmarkingDesempenhoPorCompetenciaParamsSchema = z.object({
  escolaId: z.number().int(),
  anoLetivo: z.number().int().optional(),
  anoEscolarId: z.number().int().optional(),
  turmaId: z.number().int().optional(),
  alunoId: z.number().int().optional(),
  categoriaId: z.number().int().optional(),
  nomModelo: z.string().optional(),
});

export type GetBenchmarkingDesempenhoPorCompetenciaParams = z.infer<
  typeof getBenchmarkingDesempenhoPorCompetenciaParamsSchema
>;

export const getBenchmarkingDesempenhoPorCompetencia = httpGetAdapter<
  PerformanceByCompetenceResponse,
  GetBenchmarkingDesempenhoPorCompetenciaParams
>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/desempenho-por-competencia`,
  schema: performanceByCompetenceResponseSchema,
  mapParams: ({ escolaId: _escolaId, ...rest }) => rest,
});
